/* eslint-disable */

const hasAccessForFields = (accessLevels, user, fields) => fields.find(field => {
  const levels = field.permissible_access_levels || [];
  // eslint-disable-next-line max-len
  return levels.find(pal => pal.permission_set_id === user?.permission_set?.id && accessLevels.includes(pal.access_level));
});

// :: String -> String
const capitalize = input =>{
  if (input) return  input.substring(0, 1).toUpperCase() + input.substring(1);
  else  return null;
}


// :: String -> String

const desnake = input => input.split('_').join(' ');

const formatPhone = (num) => {
  if(!num) return ''
  return num.replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

// ::  String -> String
const declassify = input => {
  const matches = Array.from(input.matchAll(/[A-Z]/g)).map(m => m[0]);
  const words = input.split(/(?=[A-Z])/).filter(Boolean);
  const combined = words.map((word, index) => (matches[index] || '') + word);
  return combined.join(' ');
};


const hasAccessLevel = (field, accessLevel, user) =>
    user && hasAccessForFields ([accessLevel], user, [field]);

const singularize = function (word) {
  if (!word) {
    return word;
  }
  if (word.slice(-1) !== 's') {
    return word;
  }
  if (word.slice(-3) === 'ies') {
    return `${word.slice(0, -3)}y`;
  }
  return word.slice(0, -1);
};
const bytes = function (bytes, precision = 1) {
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
  const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
  const number = Math.floor(Math.log(bytes) / Math.log(1024));

  return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision)
      + ' '
      + units[number];
};
export {
  hasAccessLevel,
  hasAccessForFields,
  singularize,
  desnake,
  formatPhone,
  capitalize,
  declassify,
  bytes,
};